export enum RECOMMENDATIONS_TYPES {
  LONG_TERM_EQUIPMENT = 1,
  MEDICATIONS_EXPIRE_MSG_SINGLE = 2,
  MEDICATIONS_EXPIRE_MSG_GROUP = 3,
  CONSUMEQUIP_ORDER_REMINDER_SINGLE = 4,
  TREATMENTS_ORDER_REMINDER_SINGLE = 5,
}
